import { Loader2 } from "lucide-react";
import type { CSSProperties } from "react";

interface LoadingSpinnerProps {
	message?: string;
	subMessage?: string;
	size?: "sm" | "md" | "lg";
	className?: string;
	style?: CSSProperties;
}

export function LoadingSpinner({
	message = "Ma'lumotlar yuklanmoqda...",
	subMessage = "Iltimos, kuting...",
	size = "md",
	className = "",
	style,
}: LoadingSpinnerProps) {
	const iconSize = size === "sm" ? 18 : size === "lg" ? 30 : 22;
	const pad = size === "sm" ? 12 : size === "lg" ? 36 : 24;

	return (
		<div
			className={`loading-container ${className}`}
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				padding: pad,
				gap: 12,
				fontFamily: "'Inter', sans-serif",
				...style,
			}}
		>
			<div
				style={{
					position: "relative",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					width: iconSize + 22,
					height: iconSize + 22,
					borderRadius: "50%",
					background: "rgba(0, 201, 141, 0.09)",
					border: "1px solid rgba(0, 201, 141, 0.25)",
					boxShadow: "0 0 16px rgba(0, 201, 141, 0.12)",
				}}
			>
				<Loader2
					size={iconSize}
					color="#00C98D"
					className="animate-spin"
					style={{
						animationDuration: "0.85s",
					}}
				/>
			</div>
			{message && (
				<div style={{ textAlign: "center" }}>
					<div
						style={{
							fontSize: size === "sm" ? 12 : 13,
							fontWeight: 600,
							color: "var(--app-text)",
							letterSpacing: "-0.01em",
						}}
					>
						{message}
					</div>
					{subMessage && size !== "sm" && (
						<div
							style={{
								fontSize: 11,
								color: "var(--app-text-muted)",
								marginTop: 3,
							}}
						>
							{subMessage}
						</div>
					)}
				</div>
			)}
		</div>
	);
}

export function TableLoadingRow({
	colSpan,
	message = "Ma'lumotlar yuklanmoqda...",
	subMessage,
}: {
	colSpan: number;
	message?: string;
	subMessage?: string;
}) {
	return (
		<tr>
			<td
				colSpan={colSpan}
				style={{
					padding: "48px 16px",
					textAlign: "center",
					background: "transparent",
				}}
			>
				<LoadingSpinner message={message} subMessage={subMessage} />
			</td>
		</tr>
	);
}

export function CardLoadingState({
	message = "Ma'lumotlar yuklanmoqda...",
	subMessage,
}: {
	message?: string;
	subMessage?: string;
}) {
	return (
		<div style={{ padding: "40px 16px", textAlign: "center" }}>
			<LoadingSpinner message={message} subMessage={subMessage} />
		</div>
	);
}

export function PageLoadingState({
	message = "Sahifa yuklanmoqda...",
	subMessage = "Iltimos, kuting...",
}: {
	message?: string;
	subMessage?: string;
}) {
	return (
		<div
			style={{
				minHeight: 380,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				padding: 40,
			}}
		>
			<div
				style={{
					background: "var(--app-surface)",
					border: "1px solid var(--app-border)",
					borderRadius: 16,
					padding: "36px 48px",
					boxShadow: "var(--app-shadow)",
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
				}}
			>
				<LoadingSpinner size="lg" message={message} subMessage={subMessage} />
			</div>
		</div>
	);
}
